import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Ship } from '../_models/ship';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ShipService extends ApiService {
  constructor(private http: Http) {
    super('api/ships/', http);
  }

  getShip(id: number): Observable<Ship> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}${id}/`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  getTypes(): Observable<any> {
    return this.http
      .options(`${this.apiUrl + this.endpointUrl}`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  getAssociationTypes(): Observable<any> {
    return this.http.get(`${this.apiUrl}api/ship-types/`, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  create(ship: Ship): Observable<Ship> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, JSON.stringify(ship), { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(ship: Ship): Observable<Ship> {
    const url = `${this.apiUrl + this.endpointUrl}${ship.id}/`;

    // Resolucion prolema al editar barco
    const shipData = { ...ship };
    if ('img' in shipData) {
      delete shipData.img;
    }

    return this.http.put(url, JSON.stringify(shipData), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  delete(id: number): Observable<void> {
    const url = `${this.apiUrl + this.endpointUrl}${id}/`;
    return this.http.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/ship.service.ts